import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { Await, useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "@emotion/styled";
import AuthContext from "../../context/auth/AuthContext";
import { Checkbox as MUICheckbox } from "@mui/material";
import { useCommonDetailsContext } from "../../context/Common/common";
import { GoogleMaterialIcon } from "../ui";
import { tokens } from "../../theme/tokens";
import {
  Container,
  IconButton,
  Stack,
  Typography,
  Card,
  CardContent,
  CardActions,
  Collapse,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  FormLabel,
  FormControlLabel,
  Tooltip,
  Grid,
} from "@mui/material";

import Checkbox from "@mui/material/Checkbox";
import CustomDialog from "../common/CustomDialog";

import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "@mui/material/Pagination";
import { Box } from "@mui/material";
import { AppBar } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { DateTime } from "luxon";
import { CircularProgress } from "@mui/material";
import { TrackNowButton } from "../ui";
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  // transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: "auto",
  fontSize: "15px",
  color: "#0000CC",

  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

export default function Notification() {
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const authContext = useContext(AuthContext);
  const {
    authUser,
    getCustomerNotifications,
    getFilingNotifications,
    getCustomerNotificationsWorkFlow,
    getAllNotificationCount,
    token,
    setNotificationCount,
    toLocalDateTime
  } = authContext;
  const [allNotifications, setAllNotifications] = useState([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedCustfNotifications, setSelectedCustfNotifications] = useState(
    []
  );

  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [expanded, setExpanded] = useState({
    isOpen: false,
    notificationId: null,
    sourceType: null,
    workflowId: null,
    fileTrackingId: null,
  });
  const PAGE_SIZE = 100;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [viewDetails, setViewDetails] = useState([]);

  const navigate = useNavigate();
  const backToHome = () => {
    navigate("/");
  };
  const [listNotification, setListNotification] = useState([]);

  const fetchNotificationCount = async () => {
    if (
      getAllNotificationCount
    ) {
      try {
        if (token) {
          const res = await getAllNotificationCount(token, authUser?.userId);
          console.log("fetchNotifications", res);
          console.log("fetchNotifications token", token);
          if (setNotificationCount) {
            setNotificationCount(res.totalCount);
          }
        }
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  function handleCloseClick() {
    setListNotification([]);

    setExpanded(false);
  }

  //Delete all
  async function deleteNotifications(notifications) {
    setIsLoading(true);
    let successfulRequests = [];
    let errorRequests = [];
    console.log("notificationIDS", notifications);
    const filteredNotifications = allNotifications.filter((notification) =>
      notifications.includes(notification.notificationId)
    );
    console.log("filteredNotifications", filteredNotifications);
    await Promise.all(
      filteredNotifications.map((notification) => {
        let endpointUrl, successMessage;
        if (notification.sourceType === "CustomerTracking") {
          endpointUrl = `${API_BASE_URL}/Customer/DeleteCustomerFilingTrackingNotification/${notification.notificationId}`;
          successMessage = `Deleted customer filing tracking notification with ID ${notification.notificationId}`;
        } else if (notification.sourceType === "FilingMaster") {
          endpointUrl = `${API_BASE_URL}/FilingMaster/DeleteFilingMasterWorkflowNotifications/${notification.notificationId}`;
          successMessage = `Deleted filing master workflow notification`;
        } else if (notification.sourceType === "CustomerFilingMaster") {
          endpointUrl = `${API_BASE_URL}/Customer/DeleteCustomerFilingWorkflowNotifications/${notification.notificationId}`;
          successMessage = `Deleted Customer filing  workflow notification `;
        }

        return axios
          .delete(endpointUrl)
          .then((response) => {
            console.log(successMessage);
            successfulRequests.push(response);
          })
          .catch((error) => {
            console.error(
              `Failed to delete notification with ID ${notification.notificationId}`
            );
            errorRequests.push(error);
          });
      })
    );

    if (successfulRequests.length > 0) {
      await fetchNotifications(currentPage);
      await fetchNotificationCount();
      setSelectedCustfNotifications([]);

      setDeleteSuccess(true);

      setIsLoading(false);
    }
  }

  //Confiming Delete All
  const deleteAll = () => {
    if (selectedCustfNotifications.length > 0) {
      console.log("selectedCustfNotifications", selectedCustfNotifications);
      deleteNotifications(selectedCustfNotifications);
    }
  };
  const handleDeleteAllClick = () => {
    if (selectedCustfNotifications.length > 0) {
      // const ids = selectedCustfNotifications.map(
      //   (notification) => notification.notificationId
      // );
      // console.log("**", ids);
      setOpenConfirmationDialog(true);
    } else {
      setDeleteAlert(true);
    }
  };

  //Delete Row
  async function handleDelete(id) {
    console.log("handleDelete", id);

    try {
      const response1 = await axios.delete(
        `${API_BASE_URL}/Customer/DeleteCustomerFilingTrackingNotification/${id}`
      );
      const response2 = await axios.delete(
        `${API_BASE_URL}/FilingMaster/DeleteFilingMasterWorkflowNotifications/${id}`
      );
      const response3 = await axios.delete(
        `${API_BASE_URL}/Customer/DeleteCustomerFilingWorkflowNotifications/${id}`
      );
      console.log("handleDelete response1", response1, response2, response3);

      if (response1.data.status === "Success" || response2.data.status === "Success" || response3.data.status === "Success") {

        await fetchNotifications(currentPage);
        setDeleteSuccess(true);
        fetchNotificationCount();
      } else {
        console.log("Deletion failed");
      }
    } catch (error) {
      console.error(error);
    }
  }
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    handleDelete(deleteId);
    setDeleteDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteId(null);
    setDeleteDialogOpen(false);
  };

  const fetchNotifications = async (page) => {
    console.log("fetchNotifications page", page);

    try {
      setIsLoading(true);

      const start = (page - 1) * PAGE_SIZE + 1;
      const end = page * PAGE_SIZE;

      const res = await axios.get(
        `${API_BASE_URL}/Customer/ListAllNotifications/paging?StartRow=${start}&EndRow=${end}&NotifiedUserId=${authUser?.userId}&NotificationType=Notification`
      );
      console.log("fetchNotifications res", res);
      const responseData = res?.data?.data;

      const data = responseData?.items || [];
      console.log("fetchNotifications responseData", responseData);

      setTotalPages(responseData?.totalPages || 0);

      // const filteredData = data.filter(
      //   (item) =>
      //     item.notifiedUserId === authUser?.userId &&
      //     item.notificationType === "Notification"
      // );
      console.log("fetchNotifications data", data, data.length);

      setAllNotifications(data);
    } catch (error) {
      console.log("Fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log("allNot", allNotifications);

  useEffect(() => {
    fetchNotifications(currentPage);
    setSelectedCustfNotifications([]);
  }, [currentPage]);
  console.log("allNotification ", allNotifications);

  // const handleMsCheckboxChange = (event, id) => {
  //   const checked = event.target.checked;
  //   if (checked) {
  //     // setSelectedNotifications([...selectedNotifications, id]);
  //     if (!selectedCustfNotifications.includes(id)) {
  //       selectedCustfNotifications.push(id);
  //       console.log("SELECTED NOTIFICATION", selectedCustfNotifications);
  //     }
  //   } else {
  //     const index = selectedCustfNotifications.indexOf(id);
  //     if (index !== -1) {
  //       selectedCustfNotifications.splice(index, 1);
  //       console.log("SELECTED NOTIFICATION", selectedCustfNotifications);
  //     }
  //   }
  // };
  const handleMsCheckboxChange = (event, id) => {
    const checked = event.target.checked;
    if (checked) {
      if (!selectedCustfNotifications.includes(id)) {
        setSelectedCustfNotifications([...selectedCustfNotifications, id]);
      }
    } else {
      const updatedNotifications = selectedCustfNotifications.filter(
        (notificationId) => notificationId !== id
      );
      setSelectedCustfNotifications(updatedNotifications);
    }
  };
  console.log("selectedNotif2", selectedCustfNotifications);

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      // Select all checkboxes
      const allNotificationIds = allNotifications.map(
        (notification) => notification.notificationId
      );
      setSelectedCustfNotifications(allNotificationIds);
    } else {
      // Deselect all checkboxes
      setSelectedCustfNotifications([]);
    }
  };

  const viewNotification = async (
    notificationId,
    sourceType,
    workflowId,
    fileTrackingId,
    notifiedUserId,
    notificationFrom,
    notificationTo,
    notificationCC,
    notificationSubject,
    notificationType,
    notificationText,
    informationRead,
    informationDeleted,
    createDate,
    createUser
  ) => {
    try {
      let response1 = null;
      let response2 = null;
      let notificationData = null;
      let notificationDetails = null;
      let updNotifications = null;
      let payloadTracking = {
        fileTrackingId: fileTrackingId,
        notifiedUserId: notifiedUserId,
        notificationFrom: notificationFrom,
        notificationTo: notificationTo,
        notificationCC: notificationCC,
        notificationSubject: notificationSubject,
        notificationType: notificationType,
        notificationText: notificationText,
        informationRead: true,
        informationDeleted: informationDeleted,
        createDate: createDate,
        createUser: createUser,
        notificationId: notificationId,
      };
      let payload = {
        workflowId: workflowId,
        notifiedUserId: notifiedUserId,
        notificationFrom: notificationFrom,
        notificationTo: notificationTo,
        notificationCC: notificationCC,
        notificationSubject: notificationSubject,
        notificationType: notificationType,
        notificationText: notificationText,
        informationRead: true,
        informationDeleted: informationDeleted,
        createDate: createDate,
        createUser: createUser,
        notificationId: notificationId,
      };

      if (sourceType === "CustomerTracking") {
        if (!informationRead) {
          const response3 = await axios.put(
            `${API_BASE_URL}/Customer/UpdateCustomerFilingTrackingNotification/${notificationId}`,
            payloadTracking
          );
          updNotifications = response3;
          console.log("updNotification", updNotifications);
        }
        response1 = await axios.get(
          `${API_BASE_URL}/Customer/ViewCustomerFilingTrackingNotification/${notificationId}`
        );
        console.log("res1", response1);

        if (response1) {
          notificationData = [response1.data.data];
          response2 = await axios.get(
            `${API_BASE_URL}/Customer/CustomerFileTracking/${fileTrackingId}`
          );
          console.log("res2", response2);
          if (response2) {
            notificationDetails = response2.data.data;
            console.log("notificationDetails", notificationDetails);
          }
        }
      } else if (sourceType === "FilingMaster") {
        if (!informationRead) {
          const response3 = await axios.put(
            `${API_BASE_URL}/FilingMaster/UpdateFilingMasterWorkflowNotifications/${notificationId}`,
            payload
          );

          updNotifications = response3;
          console.log("updNotification", updNotifications);
        }
        response1 = await axios.get(
          `${API_BASE_URL}/FilingMaster/ViewFilingMasterWorkflowNotifications/${notificationId}`
        );
        notificationData = [response1.data.data];

        if (response1) {
          response2 = await axios.get(
            `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowList/${workflowId}`
          );
          notificationDetails = response2.data;
        }
      } else if (sourceType === "CustomerFilingMaster") {
        if (!informationRead) {
          const response3 = await axios.put(
            `${API_BASE_URL}/Customer/UpdateCustomerFilingWorkflowNotifications/${notificationId}`,
            payload
          );
          updNotifications = response3;
          console.log("updNotifications", updNotifications);
        }
        response1 = await axios.get(
          `${API_BASE_URL}/Customer/ViewCustomerFilingWorkflowNotifications/${notificationId}`
        );
        notificationData = response1.data.data;

        if (response1) {
          response2 = await axios.get(
            `${API_BASE_URL}/Customer/CustomerFilingMasterWorkflowbyid/${workflowId}`
          );
          notificationDetails = response2.data;
        }
      }

      if (notificationData && notificationDetails) {
        // const combainedData = [...notificationData, ...notificationDetails];
        if (updNotifications) {
          await fetchNotificationCount();
        }
        setListNotification(notificationData);
        setViewDetails(notificationDetails);
        console.log("ViewDetails", notificationDetails);

        // console.log("ListNotification", combainedData);

        setExpanded({
          isOpen: true,
          notificationId,
          sourceType,
          workflowId,
          fileTrackingId,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };


  const handleDeleteSuccess = () => {
    setDeleteSuccess(() => false);
  };
  const handleDeleteAlert = () => {
    setDeleteAlert(() => false);
  };
  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy hh:mm:ss");

      return _date;
    } else return "";
  };
  const toDueDateLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yyyy");

      return _date;
    } else return "";
  };
  useEffect(() => {
    if (authUser && authUser?.userId) fetchNotificationCount();
  }, [authUser]);
  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
      <Box sx={{ px: { xs: 2, sm: 3, md: 4 } }}>

        <CustomDialog
          visible={deleteSuccess}
          onHide={handleDeleteSuccess}
        >
          Notifications deleted successfully!
        </CustomDialog>

        <CustomDialog
          visible={deleteAlert}
          onHide={handleDeleteAlert}
        >
          Please Select The Notifications.
        </CustomDialog>

        <CustomDialog
          visible={deleteDialogOpen}
          onHide={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
        >
          Are you sure you want to delete this notification?
        </CustomDialog>

        <CustomDialog
          visible={openConfirmationDialog}
          onHide={() => setOpenConfirmationDialog(false)}
          onConfirm={() => {
            deleteAll();
            setOpenConfirmationDialog(false);
          }}
        >
          Are you sure you want to delete these notifications?
        </CustomDialog>
        <div>
          <Stack direction="column" spacing={2}>
            <AppBar
              position="relative"
              color="inherit"
              sx={{
                justifyContent: "center",
                borderRadius: "8px",
                minHeight: "64px",
                px: 2, // horizontal padding
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{ height: "100%" }} // 👈 fill full height
              >
                <IconButton
                  // sx={{ display: { xs: "none", md: "flex" } }}
                  onClick={backToHome}
                >
                  <ArrowBack fontSize="medium" />
                </IconButton>

                <Typography variant="h6">
                  NOTIFICATIONS
                </Typography>
              </Stack>
            </AppBar>

            <AppBar
              position="relative"
              color="inherit"
              sx={{ borderRadius: "8px" }}
            >
              <div
                style={{
                  display: "grid",
                  marginTop: "30px",
                }}
              >{
                  allNotifications.length === 0 ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "300px", // 👈 controls vertical centering
                        textAlign: "center",
                      }}
                    >
                      <Typography>No new notifications...</Typography>
                    </Box>
                  ) : (
                    <Container>
                      <Stack direction="row" justifyContent="space-between">
                        <div>
                          <FormControlLabel
                            sx={{
                              gridRow: "1",
                              justifyContent: "end",
                              textAlign: "right",
                            }}
                            label="Select all"
                            control={
                              <MUICheckbox
                                onChange={handleSelectAllChange}
                                checked={
                                  selectedCustfNotifications.length ===
                                  allNotifications.length
                                }
                              />
                            }
                          ></FormControlLabel>
                        </div>
                        <div>

                          <TrackNowButton variant="primary" onClick={handleDeleteAllClick}>
                            DELETE
                          </TrackNowButton>
                        </div>
                      </Stack>
                    </Container>
                  )
                }

                < div >
                  {
                    allNotifications.map((notification) => (
                      <div style={{ marginRight: "20px" }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "60px 1fr",
                            marginTop: "30px",

                          }}
                        >
                          <FormControlLabel
                            sx={{
                              gridColumn: "1",
                              justifyContent: "end",
                              textAlign: "right",
                            }}
                            control={
                              <Checkbox
                                onChange={(event) =>
                                  handleMsCheckboxChange(
                                    event,
                                    notification.notificationId
                                  )
                                }
                                checked={selectedCustfNotifications.includes(
                                  notification.notificationId
                                )}
                              />
                            }
                          ></FormControlLabel>
                          <Card
                            sx={{
                              flexGrow: 1,
                              backgroundColor: "#F1F2F6",
                              gridColumn: "2",
                              width: "100%",
                              maxWidth: "100%"
                            }}
                          >
                            <Stack direction="column">
                              <CardContent>
                                {notification.customerName ? (
                                  <Grid container>
                                    {/* <Typography
                                    gutterBottom
                                    variant="subtitle1"
                                    component="div"
                                    sx={{
                                      color: "#424242",
                                      fontSize: "15px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {notification.notificationSubject}
                                  </Typography> */}
                                    <Grid
                                      style={{
                                        textAlign: "left",
                                      }}
                                      xs={3}
                                    >
                                      <Typography
                                        gutterBottom
                                        variant="subtitle1"
                                        component="div"
                                        sx={{
                                          color: "#424242",
                                          fontSize: "15px",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        {notification?.notificationSubject?.length >
                                          21 ? (
                                          <Tooltip
                                            title={
                                              notification?.notificationSubject
                                            }
                                          >
                                            <span>
                                              {notification?.notificationSubject?.slice(
                                                0,
                                                21
                                              )}
                                              ...
                                            </span>
                                          </Tooltip>
                                        ) : (
                                          notification?.notificationSubject
                                        )}{" "}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      style={{
                                        textAlign: "center",
                                      }}
                                      xs={4}
                                    >
                                      <Stack direction="column">
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Filing Name
                                        </Typography>
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          {notification.filingName.length > 36 ? (
                                            <Tooltip
                                              title={notification.filingName}
                                            >
                                              <span>
                                                {notification.filingName.slice(
                                                  0,
                                                  36
                                                )}
                                                ...
                                              </span>
                                            </Tooltip>
                                          ) : (
                                            notification.filingName
                                          )}
                                        </Typography>
                                      </Stack>
                                    </Grid>

                                    <Grid
                                      style={{
                                        textAlign: "center",
                                      }}
                                      xs={3}
                                    >
                                      <Stack direction="column">
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Client Name
                                        </Typography>
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          {notification.customerName.length >
                                            25 ? (
                                            <Tooltip
                                              title={notification.customerName}
                                            >
                                              <span>
                                                {notification.customerName.slice(
                                                  0,
                                                  25
                                                )}
                                                ...
                                              </span>
                                            </Tooltip>
                                          ) : (
                                            notification.customerName
                                          )}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid
                                      style={{
                                        textAlign: "right",
                                      }}
                                      xs={2}
                                    >
                                      <Typography
                                        style={{
                                          color: "grey",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {toLocalDateTime && toLocalDateTime(notification.createDate)}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  <Grid container>
                                    <Grid
                                      style={{
                                        textAlign: "left",
                                      }}
                                      xs={4}
                                    >
                                      <Typography
                                        gutterBottom
                                        variant="subtitle1"
                                        component="div"
                                        sx={{
                                          color: "#424242",
                                          fontSize: "15px",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        {notification?.notificationSubject?.length >
                                          20 ? (
                                          <Tooltip
                                            title={
                                              notification?.notificationSubject
                                            }
                                          >
                                            <span>
                                              {notification?.notificationSubject?.slice(
                                                0,
                                                20
                                              )}
                                              ...
                                            </span>
                                          </Tooltip>
                                        ) : (
                                          notification?.notificationSubject
                                        )}{" "}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      style={{
                                        textAlign: "center",
                                      }}
                                      xs={5}
                                    >
                                      <Stack direction="column">
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Filing Name
                                        </Typography>
                                        <Typography
                                          gutterBottom
                                          variant="subtitle1"
                                          component="div"
                                          sx={{
                                            color: "#424242",
                                            fontSize: "15px",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          {notification &&
                                            notification.filingName &&
                                            notification.filingName.length > 30 ? (
                                            <Tooltip
                                              title={notification.filingName}
                                            >
                                              <span>
                                                {notification.filingName.slice(
                                                  0,
                                                  30
                                                )}
                                                ...
                                              </span>
                                            </Tooltip>
                                          ) : (
                                            notification &&
                                            notification.filingName
                                          )}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                    <Grid
                                      style={{
                                        textAlign: "right",
                                      }}
                                      xs={3}
                                    >
                                      <Typography
                                        style={{
                                          color: "grey",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {toLocalDateTime && toLocalDateTime(notification.createDate)}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                )}
                              </CardContent>
                              <CardActions sx={{ paddingY: "0px" }}>
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  sx={{ flexGrow: 1, mr: 1 }}
                                >
                                  <div>
                                    <ExpandMore
                                      expand={
                                        expanded.isOpen &&
                                        expanded.notificationId ===
                                        notification.notificationId &&
                                        expanded.sourceType ===
                                        notification.sourceType &&
                                        expanded.workflowId ===
                                        notification.workflowId
                                      }
                                      onClick={() => {
                                        if (
                                          expanded.isOpen &&
                                          expanded.notificationId ===
                                          notification.notificationId &&
                                          expanded.sourceType ===
                                          notification.sourceType &&
                                          expanded.workflowId ===
                                          notification.workflowId
                                        ) {
                                          setExpanded({
                                            isOpen: false,
                                            notificationId: null,
                                            sourceType: null,
                                            workflowId: null,
                                            fileTrackingId: null,
                                          });
                                        } else {
                                          viewNotification(
                                            notification.notificationId,
                                            notification.sourceType,
                                            notification.workflowId,
                                            notification.fileTrackingId,
                                            notification.notifiedUserId,
                                            notification.notificationFrom,
                                            notification.notificationTo,
                                            notification.notificationCC,
                                            notification.notificationSubject,
                                            notification.notificationType,
                                            notification.notificationText,
                                            notification.informationRead,
                                            notification.informationDeleted,
                                            notification.createDate,
                                            notification.createUser
                                          );
                                        }
                                      }}
                                      aria-label="show more"
                                    >
                                      View Details
                                    </ExpandMore>
                                  </div>
                                  <div>
                                    <IconButton>
                                      <GoogleMaterialIcon name="delete_forever" color={primaryColor} onClick={() =>
                                        handleDeleteClick(
                                          notification.notificationId
                                        )
                                      } />
                                      {/* <DeleteIcon
                                        onClick={() =>
                                          handleDeleteClick(
                                            notification.notificationId
                                          )
                                        }
                                      /> */}
                                    </IconButton>
                                    {expanded.isOpen &&
                                      expanded.notificationId ===
                                      notification.notificationId &&
                                      expanded.sourceType ===
                                      notification.sourceType ? (
                                      <IconButton
                                        sx={{
                                          height: "40px",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <CloseIcon onClick={handleCloseClick} />
                                      </IconButton>
                                    ) : null}
                                  </div>
                                </Stack>
                              </CardActions>
                            </Stack>

                            <Collapse
                              in={
                                expanded.isOpen &&
                                expanded.notificationId ===
                                notification.notificationId &&
                                expanded.sourceType === notification.sourceType
                              }
                              timeout="auto"
                              unmountOnExit
                            >
                              <CardContent
                                sx={{
                                  maxHeight: "25vh",
                                  minHeight: 150,
                                }}
                              >
                                <TableContainer>
                                  <TableHead>
                                    {notification.sourceType ===
                                      "CustomerTracking" ? (
                                      <>
                                        {" "}
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "25vw",
                                          }}
                                        >
                                          Message
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "17vw",
                                          }}
                                        >
                                          Filing Frequency
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "12vw",
                                          }}
                                        >
                                          Jurisdiction
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "13vw",
                                          }}
                                        >
                                          Due date
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "55vw",
                                          }}
                                        >
                                          Notes
                                        </TableCell>
                                      </>
                                    ) : (
                                      <>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "30vw",
                                          }}
                                        >
                                          Message
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "17vw",
                                          }}
                                        >
                                          Filing Frequency
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "15vw",
                                          }}
                                        >
                                          Jurisdiction
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            color: "#9E9E9E",
                                            width: "60vw",
                                          }}
                                        >
                                          Notes
                                        </TableCell>
                                      </>
                                    )}
                                  </TableHead>
                                  {listNotification.map((list, index) => {
                                    const details = viewDetails.find(
                                      (detail) =>
                                        detail.workflowId === list.workflowId
                                    );
                                    const filingFrequency = details
                                      ? details.filingFrequency
                                      : null;
                                    const jurisdiction = details
                                      ? details.juristiction
                                      : null;
                                    const notes = details ? details.notes : null;
                                    const dueDate =
                                      notification.sourceType ===
                                        "CustomerTracking" && details
                                        ? toDueDateLocalTime(details.dueDate)
                                        : null;

                                    return (
                                      <TableBody key={index}>
                                        {notification.sourceType ===
                                          "CustomerTracking" ? (
                                          <>
                                            <TableCell
                                              style={{
                                                width: "25vw",
                                              }}
                                            >
                                              {list.notificationText.length >
                                                30 ? (
                                                <Tooltip
                                                  title={list.notificationText}
                                                  arrow
                                                >
                                                  <span>
                                                    {list.notificationText.substring(
                                                      0,
                                                      30
                                                    )}
                                                    ...
                                                  </span>
                                                </Tooltip>
                                              ) : (
                                                list.notificationText
                                              )}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "17vw",
                                              }}
                                            >
                                              {filingFrequency}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "12vw",
                                              }}
                                            >
                                              {jurisdiction}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "13vw",
                                              }}
                                            >
                                              {dueDate}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "55vw",
                                              }}
                                            >
                                              {notes && notes.length > 75 ? (
                                                <Tooltip title={notes} arrow>
                                                  <span>
                                                    {notes.substring(0, 75)}...
                                                  </span>
                                                </Tooltip>
                                              ) : (
                                                notes
                                              )}
                                            </TableCell>
                                          </>
                                        ) : (
                                          <>
                                            <TableCell
                                              style={{
                                                width: "30vw",
                                              }}
                                            >
                                              {list.notificationText.length >
                                                45 ? (
                                                <Tooltip
                                                  title={list.notificationText}
                                                  arrow
                                                >
                                                  <span>
                                                    {list.notificationText.substring(
                                                      0,
                                                      45
                                                    )}
                                                    ...
                                                  </span>
                                                </Tooltip>
                                              ) : (
                                                list.notificationText
                                              )}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "16vw",
                                              }}
                                            >
                                              {filingFrequency}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "14vw",
                                              }}
                                            >
                                              {jurisdiction}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                width: "70vw",
                                              }}
                                            >
                                              {notes && notes.length > 107 ? (
                                                <Tooltip title={notes} arrow>
                                                  <span>
                                                    {notes.substring(0, 107)}...
                                                  </span>
                                                </Tooltip>
                                              ) : (
                                                notes
                                              )}
                                            </TableCell>
                                          </>
                                        )}
                                      </TableBody>
                                    );
                                  })}
                                </TableContainer>
                              </CardContent>
                            </Collapse>
                          </Card>
                        </div>
                      </div>
                    ))
                  }
                </div>
                {/* Loader */}
                {isLoading && (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                    <CircularProgress size={30} />
                  </Box>
                )}
                {/* Pagination */}
                {totalPages > 1 && (
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ marginTop: 3, marginBottom: 2 }}
                  >
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={(event, value) => setCurrentPage(value)}
                      color="primary"
                    />
                  </Stack>
                )}

              </div>
            </AppBar>

          </Stack>
        </div >
      </Box >
    </Container >
  );
}
